import React from 'react'
import {
  Card,
  CardBody,
  Flex,
  Progress,
  SimpleGrid,
  Text
} from '@chakra-ui/react'
import StatCard from './StatCard'
import { CoinData } from '../types'
import { formatNumber } from '../utils'

interface SupplyPanelProps {
  data: CoinData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const SupplyPanel = ({ data, gridTemplateColumns, statCardBg }: SupplyPanelProps) => {
  const supplyPercentage = data.market_data.max_supply 
    ? ((data.market_data.circulating_supply / data.market_data.max_supply) * 100).toFixed(2)
    : null
  
  return (
    <>
      <SimpleGrid columns={gridTemplateColumns || 1} spacing={4} mb={6}>
        <StatCard
          bg={statCardBg}
          label="Circulating Supply"
          value={`${formatNumber(data.market_data.circulating_supply)} ${data.symbol.toUpperCase()}`}
          helpText={supplyPercentage ? `${supplyPercentage}% of max supply` : undefined}
        />

        <StatCard
          bg={statCardBg}
          label="Total Supply"
          value={data.market_data.total_supply ? `${formatNumber(data.market_data.total_supply)} ${data.symbol.toUpperCase()}` : 'Unknown'}
        />

        <StatCard
          bg={statCardBg}
          label="Max Supply"
          value={data.market_data.max_supply ? `${formatNumber(data.market_data.max_supply)} ${data.symbol.toUpperCase()}` : 'Unknown'}
        />
      </SimpleGrid>

      {data.market_data.max_supply && (
        <Card bg={statCardBg} mb={6}>
          <CardBody>
            <Text mb={2}>Supply Progress</Text>
            <Progress
              value={data.market_data.max_supply ? (data.market_data.circulating_supply / data.market_data.max_supply) * 100 : 0}
              colorScheme="orange"
              size="lg"
              sx={{ '& > div': { borderRadius: 'md' } }}
            />
            <Flex justify="space-between" mt={1}>
              <Text fontSize="sm">Circulating: {formatNumber(data.market_data.circulating_supply)}</Text>
              <Text fontSize="sm">Max: {formatNumber(data.market_data.max_supply)}</Text>
            </Flex>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default SupplyPanel
